import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import styled from 'styled-components'
import { colors } from '../../../styles/colors'
import { PrimaryButton } from '../../UI/PrimaryButton'
import { getCalculatedSum } from '../../../functions/getCalculatedSum'

const Container = styled.div`
    display: flex;
    align-items: center;
    height: 185px;

    @media (max-width: 1359.98px) {
        width: 100%;
        max-width: 320px;

        height: auto;
        flex-direction: column;
        padding: 5rem 0;
        margin: 0;

        border-bottom: 1px solid ${colors.dark_blue};
    }
    
    // INCLUDED CLASSES:

    .pic,
    .product-name,
    .count-buttons,
    .price {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        @media (max-width: 1359.98px) {
            border: none;
        }
    }

    .pic {
        border-right: 1px solid ${colors.dark_blue};
        padding: 2rem;
        
        @media (max-width: 1359.98px) {
            padding: 2rem 0;
            border: none;
        }
    }

    .product-name {
        width: 380px;
        text-transform: uppercase;
        padding: 0 5rem;
        border-right: 1px solid ${colors.dark_blue};

        font-family: 'SF UI Text', sans-serif;
        font-weight: 300;
        font-size: 2.5rem;
        line-height: 150%;
        white-space: normal;
        text-align: center;
        color: ${colors.dark_blue};

        @media (max-width: 1359.98px) {
            width: 100%;
            padding: 2rem 0;
            border: none;
        }
    }

    .count-buttons {
        width: 260px;
        padding: 0 3rem;
        border-right: 1px solid ${colors.dark_blue};

        @media (max-width: 1359.98px) {
            width: 100%;
            border: none;
        }
    }
    .counter {
        width: 10rem;
        background: none;
        border: none;
        outline: none;

        font-family: 'SF UI Text', sans-serif;
        font-weight: 400;
        font-size: 3.75rem;
        text-align: center;

        ::-webkit-inner-spin-button,
        ::-webkit-outer-spin-button {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            margin: 0;
        }

        :hover {
            color: ${colors.red};
            cursor: pointer;
        }

        @media (max-width: 1359.98px) {
            border: none;
        }
    }
    .counter-btn {
        background: ${colors.dark_blue};
        color: ${colors.white};
        cursor: pointer;
        padding: 2rem;
    }
    .price {
        width: 260px;
        padding: 0 3rem;
        border-right: 1px solid ${colors.dark_blue};

        font-family: 'SF UI Text', sans-serif;
        font-weight: 400;
        font-size: 3.75rem;
        line-height: 160%;

        @media (max-width: 1359.98px) {
            width: 100%;
            border: none;
            padding: 2.5rem 0;
        }
    }
    .delete-button {
        margin-left: 3rem;

        @media (max-width: 1359.98px) {
            margin: 0;
        }
    }

`

const Pic = styled.div`
    width: 220px;
    height: 125px;

    background: url(${props => props.product_picture}) no-repeat 50% 50%;
    background-size: contain;
`

export const ProductInCart = ({ picture, name, price, count, index }) => {
    const [currentCount, setCurrentCount] = useState(count)
    const dispatch = useDispatch()

    function runChangeCountDispatch (value) {
        dispatch({ type:'CHANGE_PRODUCT_COUNT_IN_CART', index: index, count: value })
    }

    function handleCounter (value) {
        switch (value) {
            case '-':
                if (currentCount > 1 ) {
                    setCurrentCount( currentCount - 1 )
                    runChangeCountDispatch(currentCount - 1)
                }
                break
            case '+':
                setCurrentCount( currentCount + 1 )
                runChangeCountDispatch(currentCount + 1)
                break
            default:
                if ( value < 1 ) {
                    setCurrentCount( 1 )
                    runChangeCountDispatch(1)
                } else {
                    setCurrentCount(value)
                    runChangeCountDispatch(value)
                }
        }
    }

    return (
        <Container className='product'>

            <div className="pic"> <Pic product_picture={picture} /> </div>

            <div className="product-name"> {name} </div>

            <div className="count-buttons">
                <span className='counter-btn' onClick={()=> handleCounter('-') } >-</span>
                <input className='counter' type="number" value={currentCount} onChange={ (e)=> handleCounter(+e.target.value) } />
                <span className='counter-btn' onClick={()=> handleCounter('+') } >+</span>
            </div>

            <div className="price"> { getCalculatedSum(price, currentCount) }</div>
            {/*₽*/}

            <PrimaryButton onClick={()=> dispatch({ type:'REMOVE_FROM_CART', value: index })} className='delete-button' >Удалить</PrimaryButton>

        </Container>
    )
}
